import {
  toggleButtonClasses,
  toggleButtonGroupClasses,
  ToggleButtonGroupProps,
} from '@mui/material';
import { Theme } from '@mui/material/styles';

const COLORS = [
  'primary',
  'success',
  'warning',
  'error',
  'default',
  'purple',
] as const;

declare module '@mui/material/ToggleButtonGroup' {
  interface ToggleButtonGroupPropsColorOverrides {
    default: true;
  }
  interface ToggleButtonGroupProps {
    // variant?: 'soft' | 'outlined';
  }
  interface ToggleButtonGroupPropsVariantOverrides {
    // soft: true;
    // softRounded: true;
  }
}

export default function ToggleButtonGroup(theme: Theme) {
  const rootStyles = (ownerState: ToggleButtonGroupProps) => {
    const horizontalOrientation = ownerState.orientation === 'horizontal';
    const verticalOrientation = ownerState.orientation === 'vertical';

    // const softVariant = ownerState.variant === 'soft';
    // const outlinedVariant = ownerState.variant === 'outlined';

    const colorStyle = COLORS.map((color) => ({
      ...(ownerState.color === color &&
        {
          // ...(outlinedVariant && {
          //   backgroundColor: theme.palette.common.white,
          //   color: theme.palette[color][500],
          //   border: `1px solid ${theme.palette[color][300]}`,
          // }),
          // ...(softVariant && {
          //   backgroundColor: theme.palette[color][200],
          //   color: theme.palette[color][500],
          //   border: `none`,
          // }),
        }),
    }));

    const selectedStyle = {
      [`&.${toggleButtonGroupClasses.root}`]: colorStyle,
      [`.${toggleButtonClasses.root}:not(.${toggleButtonClasses.selected}):not(.${toggleButtonClasses.disabled})`]:
        COLORS.map((color) => ({
          ...(ownerState.color === color &&
            {
              // ...(softVariant && {
              //   color: `${theme.palette[color][500]} !important`,
              //   svg: {
              //     color: theme.palette[color][500],
              //   },
              // }),
              // todo: add outlined variant whenever needed
            }),
        })),
      [`.${toggleButtonClasses.root}:not(.${toggleButtonClasses.selected}).${toggleButtonClasses.disabled}`]:
        COLORS.map((color) => ({
          ...(ownerState.color === color &&
            {
              // ...(softVariant && {
              //   backgroundColor: 'transparent',
              //   border: `none`,
              //   color: `${theme.palette[color][400]} !important`,
              //   svg: {
              //     color: theme.palette[color][400],
              //   },
              // }),
              // todo: add outlined variant whenever needed
            }),
        })),
    };

    const defaultStyle = {
      // display: 'flex',
      // flexDirection: horizontalOrientation ? 'row' : 'column',
      // alignItems: 'center',
      // justifyContent: 'space-evenly',
      // flexWrap: 'wrap',
      // // gap: theme.spacing(1),
      // padding: theme.spacing(0.5),
      // borderRadius: theme.shape.borderRadius,
      border: 'none',
      gap: theme.spacing(0.5),
    };

    return { ...defaultStyle, ...selectedStyle };
  };

  return {
    MuiToggleButtonGroup: {
      defaultProps: {
        disableElevation: true,
        color: 'primary',
      },

      styleOverrides: {
        root: ({ ownerState }: { ownerState: ToggleButtonGroupProps }) => {
          return rootStyles(ownerState);
        },
      },
    },
  };
}
